import { IconProps, iconA11yProps } from '../types';

export const Plus = ({ classNames, label }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" className={classNames} {...iconA11yProps(label)}>
        <path d="M12 3V21" />
        <path d="M3 12H21" />
    </svg>
);
